import { Flex, FlexProps } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { radius } from "@libertify/ui";

export const ClonedPreviewCard = ({ children, ...props }: FlexProps) => {
  const { theme } = useAntTheme();
  return (
    <Flex
      align="center"
      justify="center"
      vertical
      {...props}
      style={{
        padding: 24,
        backgroundColor: theme.colorLightGrey,
        borderRadius: radius.box,
        margin: "5px 20px",
        minHeight: 0,
        ...props.style,
      }}
    >
      {children}
    </Flex>
  );
};
